document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || !target.closest) return;

  var button = target.closest('[data-add-to-cart], [data-cart-bar-add-to-cart]');
  if (!button) return;

  // Only the buy box and the sticky cart bar add the product this page is for, which is the product
  // Klaviyo published as `item`. Any other add-to-cart button adds something else, so it reports
  // nothing rather than the wrong product.
  if (!button.closest('form[data-product-form]') && !button.hasAttribute('data-cart-bar-add-to-cart')) return;
  if (typeof item === 'undefined' || !item) return;

  window._learnq = window._learnq || [];
  window._learnq.push(['track', 'Added to Cart', item]);
});
